import React from 'react';
import Modal from 'react-bootstrap/Modal';


export default class SubStepThreeModal extends React.Component {

    
    render() {

        return (
            <Modal show={this.props.isShowing} size={"lg"} centered  onHide={this.props.close}>
                <Modal.Header>

                    <Modal.Title className="w-100 text-center">
                        Subscribed!
                    </Modal.Title>
                    <button type="button" style={{}}
                            onClick={this.props.close} className="close">
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>
                <Modal.Body className={"text-center"}>

                    <h5> Thank you! We will send your flight notifications to: {this.props.userInfo}</h5>
                </Modal.Body>

            </Modal>
        );
    }
}